module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'component z-input-image can-loading': true,
      'loading': _vm.loading,
      'disabled': _vm.$props.disabled,
        'readonly': _vm.$props.readonly
    },
    style: ('width: calc(' + _vm.$props.width + ')')
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabel),
      expression: "showLabel"
    }]
  }, [_vm._v(_vm._s(_vm.$props.label + (_vm.$props.readonly ? ' (Только для чтения)' : '')))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-dense",
    attrs: {
      "width": _vm.$props.width
    },
    on: {
      "click": _vm.openFileDialog
    }
  }, [_vm._v(_vm._s(_vm.$props.buttonText))]), _vm._v(" "), (_vm.uploadError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.uploadError))]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "name": _vm.$props.name,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "placeholder": _vm.$props.placeholder,
      "min": _vm.$props.min,
      "max": _vm.$props.max,
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": _vm.changeFiles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "z-input-image__container"
  }, [_c('div', {
    staticClass: "z-input-image__preview-images"
  }, _vm._l((_vm.previewImages), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "z-input-image__preview-image"
    }, [_c('img', {
      attrs: {
        "src": img.src,
        "alt": 'image-' + i
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.inprogress),
        expression: "img.inprogress"
      }],
      staticClass: "z-input-image__preview-image__percent"
    }, [_vm._v(_vm._s(img.percent + '%'))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.upload),
        expression: "img.upload"
      }],
      staticClass: "z-input-image__preview-image__upload"
    }, [_c('i', {
      staticClass: "fas fa-check"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.error),
        expression: "img.error"
      }],
      staticClass: "z-input-image__preview-image__error"
    }, [_c('i', {
      staticClass: "fas fa-exclamation"
    })])])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.error),
      expression: "$props.error"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.$props.error))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f8c920e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInputImage.vue
// module id = 1229
// module chunks = 0